import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { DateInput, Edit, Loading, required, SelectInput, SimpleForm, TextInput, useEditController } from 'react-admin';
import { dateArriveValidation, getAdr, statusCampagne, typeCampagne } from '../references.js';

const  EditCampagne =(props,...rest) => {

    const [defaultValues, setDefaultValues] = useState();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const { record } = useEditController(props);
    useEffect(() => {
      if(record && record.id && record.depart && record.arrive && record.depart.id && record.arrive.id){
        let ret=getAdr(record.type);
        //console.log(ret)
        var valInitiales={"camp_id":record.id,
          "numero":record.numero,
          "adrDeptId":record.depart.id,
          "adrArrId":record.arrive.id,
          "dateDepart":record.dateDepart,
          "dateArrive":record.dateArrive,
          "commentaire":record.commentaire,
          "status":record.status,
          list_adr_dep:ret.list_adr_dep,
          list_adr_arr:ret.list_adr_arr
         
       };
       setDefaultValues(valInitiales);
      }
    }, []);


    if(!record) return <Loading loadingPrimary="app.page.loading" loadingSecondary="Chargement ..." />

    //console.log(defaultValues);
    const TypeChange=(e)=>{
      //console.log(getAdr(e.target.value))
      setDefaultValues(()=>getAdr(e.target.value))
  }
  return (
  
      <Edit {...props} title={"Mise à jour de la campagne : "+record.code}   >
        <SimpleForm {...props}  submitOnEnter={true} redirect="show" margin="none"  initialValues={defaultValues}  >
            
        { isSmall ?
              <SelectInput {...rest} fullWidth source="status" label="Status" validate={required()} choices={statusCampagne} />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="status" label="Status" validate={required()} choices={statusCampagne}  />
          }  
          { isSmall ?
              <SelectInput {...rest} fullWidth source="type" label="Type campagne" validate={required()} choices={typeCampagne} onChange={TypeChange}  />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="type" label="Type campagne" validate={required()} choices={typeCampagne}  onChange={TypeChange} />
          }  
      {isSmall ?     
            <SelectInput {...rest} fullWidth   source="adrDeptId" 
                label="Adresse départ" validate={required()} 
                choices={defaultValues!==null && defaultValues.list_adr_dep? defaultValues.list_adr_dep: []}   
                />
            :
            
            <SelectInput {...rest}    
                style={{width:'50%'}} source="adrDeptId" 
                label="Adresse départ" validate={required()} 
                choices={defaultValues && defaultValues.list_adr_dep ? defaultValues.list_adr_dep: []} 
                />
        }
        {
            isSmall ?     
            <SelectInput {...rest} fullWidth   source="adrArrId" label="Adresse arrivée" 
                validate={required()} 
                choices={defaultValues && defaultValues.list_adr_arr && defaultValues.list_adr_arr!=='undefined'? defaultValues.list_adr_arr: []} 
            />
            :
            
            <SelectInput {...rest}    style={{width:'50%'}} source="adrArrId" label="Adresse arrivée" 
                validate={required()} 
                choices={defaultValues && defaultValues.list_adr_arr? defaultValues.list_adr_arr: []} 
            />
        }

         { isSmall ?  
          <DateInput {...rest}  fullWidth source="dateDepart" label="Date départ"  validate={required()}   />
            :
            <DateInput {...rest}   style={{width:'50%'}}  source="dateDepart" label="Date départ"  validate={required()}   />

         }
           { isSmall ?  
          <DateInput {...rest} fullWidth  source="dateArrive" label="Date arrivé"  validate={[dateArriveValidation]}   />
            :
            <DateInput {...rest} style={{width:'50%'}}  source="dateArrive" label="Date arrivé"  validate={[dateArriveValidation]}   />
           }
                    { isSmall ?  
          <TextInput  {...rest} fullWidth  multiline source="numero"  label="Numéro"  />
          :
          <TextInput  {...rest} style={{width:'50%'}}  multiline source="numero"  label="Numéro"  />

           }
           { isSmall ?  
          <TextInput  {...rest} fullWidth  multiline source="commentaire"  label="Commentaire"  />
          :
          <TextInput  {...rest} style={{width:'50%'}}  multiline source="commentaire"  label="Commentaire"  />

           }

        </SimpleForm>
    </Edit>
    );
}

export default EditCampagne;